export default __webpack_public_path__ + "static/media/hero-bundle@2x.aa0281f2.png";